const ViewColumn2 = ({ size = 24, color = "var(--primary-text-color)" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            height={`${size}px`}
            width={`${size}px`}
            viewBox="0 -960 960 960"
            fill={color}
        >
            <path d="M120-200v-560h720v560H120Zm80-80h240v-400H200v400Zm320 0h240v-400H520v400Z" />
        </svg>
    )
}

export default ViewColumn2;

